// extracted by mini-css-extract-plugin
export default {"root":"IconGift_root__7+2S1"};